import MenuItem from 'material-ui/MenuItem';
import { RadioButton } from 'material-ui/RadioButton';
import RaisedButton from 'material-ui/RaisedButton';
import { Tab, Tabs } from 'material-ui/Tabs';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import SwipeableViews from 'react-swipeable-views';
import { Field, FieldArray, formValueSelector, reduxForm } from 'redux-form';
import { RadioButtonGroup } from 'redux-form-material-ui';
import { setSliderIndex } from 'src/actions/form';
import { Currency, Entities, isMoneyAmount, setMoneyCurrency, TOMCAT_URL, validatePrice } from 'src/common/index';
import {
    renderCheckbox,
    renderInput,
    renderInputNumber,
    renderRichTextEditorMultiLang,
    renderSelectField,
    supportedRegionItems,
    validateJson,
    validatePercentage,
    validateUrlMultiLanguage,
} from 'src/components/misc/redux-form-helpers';
import { integrationAsyncValidate, isBlank, isUrl } from 'src/components/misc/validations';
import { FINDER_LANGUAGES } from 'src/i18n';
import { IntegrationFeeType } from 'src/utils/constants';
import { isNullOrUndefined } from 'src/utils/helpers';
import MultiLanguageInput from 'src/components/misc/multi-language-input';
import { isNumber } from 'lodash';

class IntegrationEditForm extends Component {
    componentWillMount() {
        this.props.setSliderIndex(0);
    }

    render() {
        const { handleSubmit, feeType, selectedSliderIndex, t } = this.props;
        return (
            <form className="form-horizontal" onSubmit={handleSubmit}>
                <Tabs onChange={value => this.props.setSliderIndex(value)} value={selectedSliderIndex}>
                    <Tab label={t('integration.tabs.general')} value={0} />
                    <Tab label={t('integration.tabs.fees')} value={1} />
                    <Tab label={t('integration.tabs.settings')} value={2} />
                    <Tab label={t('integration.tabs.overrides')} value={3} />
                    <Tab label={t('integration.tabs.payment')} value={4} />
                </Tabs>

                <SwipeableViews index={selectedSliderIndex} onChangeIndex={value => this.props.setSliderIndex(value)}>
                    <div className="view">{this.renderPrimaryFields()}</div>
                    <div className="view">{this.renderFees()}</div>
                    <div className="view">{this.renderSettings()}</div>
                    <div className="view">{this.renderOverrides()}</div>
                    <div className="view">{this.renderPaymentOptions()}</div>
                </SwipeableViews>
            </form>
        );
    }

    renderPrimaryFields() {
        const { feeType, busCompanies, t, initialValues } = this.props;

        const companyMenuItems = [<MenuItem key={-1} value="" primaryText="-" />];

        const searchCompany =
            this.props.initialValues.company !== '' ? this.props.initialValues.company : this.props.company;
        const currentCompany = this.props.busCompanies.find(company => company._links.self.href === searchCompany);
        busCompanies
            .sort((a, b) => a.companyName.localeCompare(b.companyName))
            .forEach((value, index) => {
                companyMenuItems.push(
                    <MenuItem key={index} value={value['_links']['self']['href']} primaryText={value.companyName} />,
                );
            });

        return (
            <>
                <legend className="legend legend-event-form ">{t('common_phrases.common')}</legend>
                <div className="row voffset">
                    <div className="col-md-6">
                        <Field name="name" label={`${t('common_phrases.name')} *`} component={renderInput} />
                    </div>
                    <div className="col-md-6">
                        <Field name="url" label={`${t('booked_tasks.partner_url')} *`} component={renderInput} />
                    </div>
                </div>
                <div className="row voffset">
                    <div className="col-md-12">
                        <Field
                            name="localizedUrls"
                            placeholder={t('booked_tasks.partner_url_localized')}
                            label={t('booked_tasks.partner_url_localized')}
                            t={t}
                            component={MultiLanguageInput}
                            operatorDefaultLanguage={'de'}
                            componentType={'renderInput'}
                            isUrlValidation={true}
                            validate={validateUrlMultiLanguage}
                        />
                    </div>
                </div>

                <div className="row voffset">
                    <div className="col-md-6">
                        <Field name="company" label={t('common_phrases.company')} component={renderSelectField}>
                            {companyMenuItems}
                        </Field>
                    </div>
                    <div className="col-md-6">
                        <Field name="allCompanies" label={t('booked_tasks.all_companies')} component={renderCheckbox} />
                        <Field name="ownedByBusfinder" label={t('booked_tasks.owned_by')} component={renderCheckbox} />
                    </div>
                </div>
                {currentCompany !== undefined && currentCompany.integrationBusRequestFormEnabled && (
                    <>
                        <legend className="legend legend-event-form">Layout</legend>
                        <div className="row voffset">
                            <div className="col-md-12">
                                <Field
                                    name="settings.branding.appEntry"
                                    label={t('integration.settings.branding.appEntry')}
                                    component={renderSelectField}>
                                    {initialValues.defaultBusRequestFormSettings.appEntries.map(layout => (
                                        <MenuItem key={layout} value={layout} primaryText={layout} />
                                    ))}
                                </Field>
                                <Field
                                    name="settings.busRequestForm.variant"
                                    label={t('integration.settings.busRequestForm.variant')}
                                    component={renderSelectField}>
                                    {initialValues.defaultBusRequestFormSettings.defaultFormVariant.map(layout => (
                                        <MenuItem key={layout} value={layout} primaryText={layout} />
                                    ))}
                                </Field>
                                <Field
                                    name="settings.busRequestForm.maxWidth"
                                    label={t('integration.settings.busRequestForm.maxWidth')}
                                    component={renderSelectField}>
                                    {initialValues.defaultBusRequestFormSettings.defaultFormWidth.map(layout => (
                                        <MenuItem key={layout} value={layout} primaryText={layout} />
                                    ))}
                                </Field>
                            </div>
                        </div>
                    </>
                )}
            </>
        );
    }

    renderFees() {
        const { feeType, t } = this.props;
        const searchCompany =
            this.props.initialValues.company !== undefined ? this.props.initialValues.company : this.props.company;

        const currentCompany = this.props.busCompanies.find(company => company._links.self.href === searchCompany);

        return (
            <>
                <legend className="legend legend-event-form">{t('integration.fee_type')}</legend>
                <div className="row">
                    <div className="col-md-12 voffset">
                        <Field
                            name="feeType"
                            label={`${t('integration.fee_type')} *`}
                            defaultSelected={this.props.initialValues.feeType}
                            component={RadioButtonGroup}>
                            <RadioButton
                                value={IntegrationFeeType.PROVISION}
                                label={t('integration.fee_type_option.provision')}
                            />
                            <RadioButton
                                value={IntegrationFeeType.PRICE_PER_REQUEST}
                                label={t('integration.fee_type_option.price_per_request')}
                            />
                        </Field>
                    </div>
                </div>
                <div className="row" hidden={feeType !== IntegrationFeeType.PROVISION}>
                    <div className="col-md-6 voffset">
                        <Field
                            name="fee"
                            disabled={feeType === IntegrationFeeType.PRICE_PER_REQUEST}
                            label={`${t('integration.fee_type_option.provision')} *`}
                            component={renderInput}
                        />
                    </div>
                </div>

                <div className="row" hidden={feeType !== IntegrationFeeType.PRICE_PER_REQUEST}>
                    <div className="col-md-12 voffset">
                        <Field
                            name="minIntegrationRequestFee.amount"
                            component={renderInputNumber}
                            hidden={feeType !== IntegrationFeeType.PRICE_PER_REQUEST}
                            label={`${t('integration.min_request_fee')} *`}
                            type="number"
                            defaultValue={15}
                        />
                    </div>
                    <div className="col-md-12">
                        <FieldArray
                            name="requestFees"
                            component={renderRequestFees}
                            hidden={feeType !== IntegrationFeeType.PRICE_PER_REQUEST}
                            {...{
                                t,
                            }}
                        />
                    </div>
                </div>
                <div hidden={currentCompany !== undefined && !currentCompany.integrationBusRequestFormEnabled}>
                    <legend className="legend legend-event-form">Busanfragen Gebühren</legend>
                    <div className="row">
                        <div className="col-md-12">
                            <FieldArray
                                name="requestFeesBusRequest"
                                component={renderRequestFees}
                                hidden={false}
                                {...{
                                    t,
                                }}
                            />
                        </div>
                    </div>
                </div>
                <legend className="legend legend-event-form">{t('integration.fee_type_offer')}</legend>
                <div className="row">
                    <div className="col-md-12">
                        <FieldArray
                            name="offerCreationFees"
                            component={renderRequestFees}
                            hidden={false}
                            {...{
                                t,
                            }}
                        />
                    </div>
                </div>
            </>
        );
    }

    componentDidUpdate(prevProps) {
        // Check if disableResultFilter was just toggled from true to false
        if (prevProps.disableResultFilter && !this.props.disableResultFilter) {
            // Programmatically uncheck the hidden field
            this.props.change('settings.searchResults.showNetPriceFilter', false);
        }
    }

    renderSettings() {
        const { settings, t, integration } = this.props;
        const requiredCustomerMail = settings && settings.searchResults && settings.searchResults.requireCustomerMail;
        const singleCompanyIntegration = integration !== undefined && !integration.allCompanies;
        return (
            <>
                <div className="row voffset">
                    <div className="col-md-12">
                        <legend className="legend">{t('integration.settings.authentication.title')}</legend>
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="settings.authentication.disableAuthentication"
                            label={t('integration.settings.authentication.disableAuthentication')}
                            component={renderCheckbox}
                        />
                    </div>
                </div>

                <div className="row voffset">
                    <div className="col-md-12">
                        <legend className="legend">{t('integration.settings.tutorial.title')}</legend>
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="settings.tutorial.disableSearchFormTour"
                            label={t('integration.settings.tutorial.disableSearchFormTour')}
                            component={renderCheckbox}
                        />
                    </div>
                </div>

                <div className="row voffset">
                    <div className="col-md-12">
                        <legend className="legend">{t('integration.settings.booking.title')}</legend>
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="settings.booking.enableReservation"
                            label={t('integration.settings.booking.enableReservation')}
                            component={renderCheckbox}
                        />
                    </div>
                    {!this.props.forceCustomerToOrganizeHotelRoom && (
                        <div className="col-md-6">
                            <Field
                                name="settings.booking.disableDriverRoomsChoice"
                                label={t('integration.settings.booking.disableDriverRoomsChoice')}
                                component={renderCheckbox}
                            />
                        </div>
                    )}
                </div>

                <div className="row voffset">
                    <div className="col-md-6">
                        <Field
                            name="settings.booking.disableCustomerBookingAmend"
                            label={t('integration.settings.booking.disableCustomerBookingAmend')}
                            component={renderCheckbox}
                        />
                    </div>
                    {singleCompanyIntegration && !this.props.disableDriverRoomsChoice && (
                        <>
                            <div className="col-md-6">
                                <Field
                                    name="settings.booking.forceCustomerToOrganizeHotelRoom"
                                    label={t('integration.settings.booking.forceCustomerToOrganizeHotelRoom')}
                                    component={renderCheckbox}
                                />
                            </div>
                        </>
                    )}

                    {singleCompanyIntegration && (
                        <>
                            <div className="col-md-6">
                                <Field
                                    name="settings.booking.enableBookOrRequestOfferOptionAtCheckout"
                                    label={t('integration.settings.booking.enableBookOrRequestOfferOptionAtCheckout')}
                                    component={renderCheckbox}
                                />
                            </div>

                            {this.props.enableBookOrRequestOfferOptionAtCheckout && (
                                <div className="col-md-6">
                                    <Field
                                        name="settings.booking.discountOnImmediateBooking"
                                        label={t('integration.settings.booking.discountOnImmediateBooking')}
                                        component={renderInput}
                                        type="number"
                                    />
                                </div>
                            )}
                        </>
                    )}

                    {singleCompanyIntegration && (
                        <div className="col-md-6">
                            <Field
                                name="settings.booking.maxPax"
                                label={t('integration.settings.booking.maxPax')}
                                component={renderInputNumber}
                            />
                        </div>
                    )}
                </div>

                {singleCompanyIntegration && integration.company.ratioCompany && (
                    <div className="row">
                        <div className="col-md-8">
                            <Field
                                name="settings.booking.userForRatioExport"
                                label={t('integration.settings.booking.userForRatioExport')}
                                component={renderInput}
                            />
                        </div>
                    </div>
                )}

                {singleCompanyIntegration && (
                    <div className="row">
                        <div className="col-md-6">
                            <Field
                                name="settings.booking.allowSecondEmailRecipientForOffers"
                                label={t('integration.settings.booking.allowSecondEmailRecipientForOffers')}
                                component={renderCheckbox}
                            />
                        </div>
                    </div>
                )}

                <div className="row voffset">
                    <div className="col-md-12">
                        <legend className="legend">{t('integration.settings.searchResults.title')}</legend>
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="settings.searchResults.disableResultFilter"
                            label={t('integration.settings.searchResults.disableResultFilter')}
                            component={renderCheckbox}
                        />
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="settings.searchResults.disableTripCompanies"
                            label={t('integration.settings.searchResults.disableTripCompanies')}
                            component={renderCheckbox}
                        />
                    </div>
                </div>

                <div className="row voffset">
                    <div className="col-md-6">
                        <Field
                            name="settings.searchResults.requireCustomerMail"
                            label={t('integration.settings.searchResults.requireCustomerMail')}
                            component={renderCheckbox}
                        />
                    </div>
                    {requiredCustomerMail && (
                        <div className="col-md-6">
                            <Field
                                name="settings.searchResults.requireCustomerName"
                                label={t('integration.settings.searchResults.requireCustomerName')}
                                component={renderCheckbox}
                            />
                        </div>
                    )}
                </div>

                {requiredCustomerMail && (
                    <div className="row voffset">
                        <div className="col-md-12">
                            <Field
                                name="settings.searchResults.sendSearchResultsReminderMail"
                                label={t('integration.settings.searchResults.sendSearchResultsReminderMail')}
                                component={renderCheckbox}
                            />
                        </div>
                    </div>
                )}

                <div className="row voffset">
                    <div className="col-md-6">
                        <Field
                            name="settings.searchResults.applicableSchool"
                            label={t('integration.settings.searchResults.applicableSchool')}
                            component={renderCheckbox}
                        />
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="settings.searchResults.ignoreArrivalAndReturnKm"
                            label={t('integration.settings.searchResults.ignoreArrivalAndReturnKm')}
                            component={renderCheckbox}
                        />
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="settings.searchResults.limitedBusFormThreshold"
                            label={t('integration.settings.searchResults.limitedBusFormThreshold')}
                            component={renderInput}
                            type="number"
                        />
                    </div>
                    {this.props.disableResultFilter && (
                        <div className="col-md-6">
                            <Field
                                name="settings.searchResults.showNetPriceFilter"
                                label={t('integration.settings.searchResults.showNetPriceFilter')}
                                component={renderCheckbox}
                            />
                        </div>
                    )}
                </div>

                {!this.props.allCompanies && (
                    <div className="row voffset">
                        <div className="col-md-12">
                            <Field
                                name="settings.searchResults.sendConfirmationMailToCustomerOnFindMyBusRequest"
                                label={t(
                                    'integration.settings.searchResults.sendConfirmationMailToCustomerOnFindMyBusRequest',
                                )}
                                component={renderCheckbox}
                            />
                        </div>
                    </div>
                )}

                <div className="row voffset">
                    <div className="col-md-12">
                        <legend className="legend">{t('integration.settings.localization.title')}</legend>
                    </div>
                    <div className="col-md-4">
                        <Field
                            name="settings.localization.disableLanguageSwitcher"
                            label={t('integration.settings.localization.disableLanguageSwitcher')}
                            component={renderCheckbox}
                        />
                    </div>
                    <div className="col-md-4">
                        <Field
                            name="settings.localization.defaultLanguage"
                            label={t('integration.settings.localization.defaultLanguage')}
                            component={renderSelectField}>
                            {[<MenuItem key={-1} value="" primaryText="-" />].concat([
                                FINDER_LANGUAGES.map(language => (
                                    <MenuItem key={language.code} value={language.code} primaryText={language.label} />
                                )),
                            ])}
                        </Field>
                    </div>
                    <div className="col-md-4">
                        <Field
                            name="settings.localization.languageDetectionOrder"
                            label={t('integration.settings.localization.languageDetectionOrder')}
                            component={renderSelectField}
                            multiple>
                            <MenuItem
                                value="htmlTag"
                                primaryText={t(
                                    'integration.settings.localization.languageDetectionOrder_options.htmlTag',
                                )}
                            />
                        </Field>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <Field
                            name="settings.localization.disableRegionSwitcher"
                            label={t('integration.settings.localization.disableRegionSwitcher')}
                            component={renderCheckbox}
                        />
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="settings.localization.defaultRegion"
                            label={t('integration.settings.localization.defaultRegion')}
                            component={renderSelectField}>
                            {supportedRegionItems()}
                        </Field>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <Field
                            name="settings.localization.disableCurrencySwitcher"
                            label={t('integration.settings.localization.disableCurrencySwitcher')}
                            component={renderCheckbox}
                        />
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="settings.localization.defaultCurrency"
                            label={t('integration.settings.localization.defaultCurrency')}
                            component={renderSelectField}>
                            {[<MenuItem key={-1} value="" primaryText="-" />].concat(
                                Object.keys(Currency).map(currency => (
                                    <MenuItem key={currency} value={currency} primaryText={currency} />
                                )),
                            )}
                        </Field>
                    </div>
                </div>

                <div className="row voffset">
                    <div className="col-md-12">
                        <legend className="legend">{t('integration.settings.branding.title')}</legend>
                    </div>
                    <div className="col-md-4">
                        <Field
                            name="settings.branding.disableLogo"
                            label={t('integration.settings.branding.disableLogo')}
                            component={renderCheckbox}
                        />
                    </div>
                    <div className="col-md-4">
                        <Field
                            name="settings.branding.disableCookieBanner"
                            label={t('integration.settings.branding.disableCookieBanner')}
                            component={renderCheckbox}
                        />
                    </div>
                    <div className="col-md-4">
                        <Field
                            name="settings.branding.disableCo2Feature"
                            label={t('integration.settings.branding.disableCo2Feature')}
                            component={renderCheckbox}
                        />
                    </div>
                    <div className="col-md-4">
                        <Field
                            name="settings.branding.enablePremiumPartnerBranding"
                            label={t('integration.settings.branding.enablePremiumPartnerBranding')}
                            component={renderCheckbox}
                        />
                    </div>
                    <div className="col-md-4">
                        <Field
                            name="settings.branding.deactivateNewsletterSignup"
                            label={t('integration.settings.branding.deactivateNewsletterSignup')}
                            component={renderCheckbox}
                        />
                    </div>
                    <div className="col-md-4">
                        <Field
                            name="settings.branding.alwaysShowFindMyBusForm"
                            label={t('integration.settings.branding.alwaysShowFindMyBusForm')}
                            component={renderCheckbox}
                        />
                    </div>

                    <div className="col-md-4">
                        <Field
                            name="settings.branding.alwaysDisplayNetPricesAndHideFilter"
                            label={t('integration.settings.branding.alwaysDisplayNetPricesAndHideFilter')}
                            component={renderCheckbox}
                        />
                    </div>

                    <div className="col-md-12">
                        <Field
                            name="settings.branding.preloadTripCompany"
                            label={t('integration.settings.branding.preloadTripCompany')}
                            component={renderSelectField}>
                            {[<MenuItem key={-1} value="" primaryText="-" />].concat(this.tripCompanies())}
                        </Field>
                    </div>
                    <div className="col-md-12">
                        <Field
                            name="settings.branding.existingCustomerOptOutLink"
                            label={t('integration.settings.branding.existingCustomerOptOutLink')}
                            placeholder={t('integration.settings.branding.existingCustomerOptOutLink')}
                            t={t}
                            component={MultiLanguageInput}
                            operatorDefaultLanguage={'de'}
                            componentType={'renderRichTextEditorMultiLang'}
                        />
                    </div>
                    <div className="col-md-12 voffset">
                        <Field
                            name="settings.branding.dataPrivacyText"
                            label={t('integration.settings.branding.dataPrivacyText')}
                            placeholder={t('integration.settings.branding.dataPrivacyText')}
                            t={t}
                            component={MultiLanguageInput}
                            operatorDefaultLanguage={'de'}
                            componentType={'renderRichTextEditorMultiLang'}
                        />
                    </div>
                </div>

                <div className="row voffset">
                    <div className="col-md-12">
                        <legend className="legend">{t('integration.settings.theme.title')}</legend>
                    </div>
                    <div className="col-md-12">
                        <Field
                            name="settings.theme.forceColorScheme"
                            label={t('integration.settings.theme.forceColorScheme')}
                            component={renderSelectField}>
                            <MenuItem value="" primaryText="-" />
                            <MenuItem
                                value="light"
                                primaryText={t('integration.settings.theme.forceColorScheme_options.light')}
                            />
                            <MenuItem
                                value="dark"
                                primaryText={t('integration.settings.theme.forceColorScheme_options.dark')}
                            />
                        </Field>
                    </div>
                </div>
            </>
        );
    }

    tripCompanies() {
        return this.props.tripCompanies.map((company, index) => (
            <MenuItem
                key={index}
                value={`${TOMCAT_URL}api/${Entities.TRIP_COMPANY.repository}/${company.id}`}
                primaryText={company.companyName}
            />
        ));
    }

    renderOverrides() {
        const { t } = this.props;
        return (
            <>
                <div className="row voffset">
                    <div className="col-md-12">
                        <Field
                            name="themeOverrides"
                            label={t('integration.themeOverrides')}
                            component={renderInput}
                            multiline
                            rows={4}
                        />
                    </div>
                </div>
                <div className="row voffset">
                    <div className="col-md-12">
                        <Field
                            name="translationOverrides"
                            label={t('integration.translationOverrides')}
                            component={renderInput}
                            multiline
                            rows={4}
                        />
                    </div>
                </div>
            </>
        );
    }

    renderPaymentOptions() {
        const { t } = this.props;
        return (
            <>
                <div className="row">
                    <div className="col-md-12">
                        <Field
                            name="settings.onlinePayment.merchantId"
                            label={t('integration.settings.onlinePayment.merchantId')}
                            component={renderInput}
                        />
                    </div>
                    <div className="col-md-12">
                        <Field
                            name="settings.onlinePayment.apiKey"
                            label={t('integration.settings.onlinePayment.apiKey')}
                            component={renderInput}
                        />
                    </div>
                </div>
            </>
        );
    }
}

const renderRequestFees = ({ hidden, fields, t }) => (
    <div className="col-md-12 voffset" style={hidden ? { display: 'none' } : {}}>
        <div className="row">
            <div className="col-md-6">
                <div className="form-group">
                    <RaisedButton
                        secondary={true}
                        label={`+ ${t('calculation.new_rate')}`}
                        onClick={() =>
                            fields.push({
                                fromRequest: 1,
                                price: 0,
                            })
                        }
                    />
                </div>
            </div>
        </div>

        {fields.map((requestFee, index) => (
            <div key={index} className="row">
                <div className="col-md-5">
                    <div className="form-group">
                        <Field
                            name={`${requestFee}.fromRequest`}
                            label={`${t('booked_tasks.from_request')} *`}
                            component={renderInput}
                            type="number"
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <Field
                            name={`${requestFee}.price.amount`}
                            label={`${t('integration.fee_type_option.price_per_request')} *`}
                            component={renderInput}
                        />
                    </div>
                </div>
                <div className="col-md-1 voffset">
                    <button className="btn btn-sm" type="button" onClick={() => fields.remove(index)}>
                        <span className="glyphicon glyphicon-trash" />
                    </button>
                </div>
            </div>
        ))}
    </div>
);

const validate = (values, props) => {
    const { t } = props;
    const errors = {};

    if (isBlank(values.name)) errors.name = t('error_missing.fill_in_name');

    if (isBlank(values.url)) errors.url = t('error_missing.fill_in_url');
    else if (!isUrl(values.url)) errors.url = t('error_missing.fill_in_valid_url');

    if (values.maxPax && !isNumber(values.maxPax)) errors.maxPax = t('error_missing.fill_in_valid_number');
    // if(values.settings.branding.existingCustomerOptOutLink){
    //     const err =  validateBrandingSettingsUrl(values.settings.branding.existingCustomerOptOutLink)
    //     if(err.length > 0){
    //         errors.settings.branding = "enter a valid url"
    //     }
    // }

    if (values.company.length === 0) errors.company = t('error_missing.select_company');

    if (values.feeType === IntegrationFeeType.PROVISION) {
        if (isNullOrUndefined(values.fee) || values.fee.length === 0) errors.fee = t('error_missing.fill_in_provision');
        else if (!validatePercentage(values.fee)) errors.fee = t('error_hint.provision_criteria');
        else if (!/^\d{1,3}(?:\.\d)?$/i.test(values.fee))
            errors.fee = `${t('error_hint.error_invalid_format')} (######.00)`;
    }

    if (values.requestFees) errors.requestFees = validateRequestFees(values.requestFees, t);
    if (values.requestFeesBusRequest)
        errors.requestFeesBusRequest = validateRequestFees(values.requestFeesBusRequest, t);

    if (values.offerCreationFees) errors.offerCreationFees = validateRequestFees(values.offerCreationFees, t);

    if (values.themeOverrides && !validateJson(values.themeOverrides))
        errors.themeOverrides = t('error_hint.invalid_json');
    if (values.translationOverrides && !validateJson(values.translationOverrides))
        errors.translationOverrides = t('error_hint.invalid_json');

    errors.localizedUrls = {};
    if ('localizedUrls' in values && typeof values.localizedUrls === 'object') {
        for (const [key, value] of Object.entries(values.localizedUrls)) {
            if (!isUrl(value)) errors.localizedUrls[key] = t('error_missing.fill_invalid_url_or_leave_empty');
        }
    }

    if (!errors.localizedUrls || Object.keys(errors.localizedUrls).length === 0) delete errors.localizedUrls;
    if (!errors.requestFees || Object.keys(errors.requestFees).length === 0) delete errors.requestFees;
    if (!errors.requestFeesBusRequest || Object.keys(errors.requestFeesBusRequest).length === 0)
        delete errors.requestFeesBusRequest;

    if (!errors.offerCreationFees || Object.keys(errors.offerCreationFees).length === 0)
        delete errors.offerCreationFees;

    return errors;
};

const validateRequestFees = (requestFees, t) => {
    const errors = [];
    const seen = new Set();

    requestFees.forEach((requestFee, index) => {
        const error = {
            fromRequest: undefined,
            price: {
                amount: undefined,
            },
        };

        if (requestFee.fromRequest < 1) {
            error.fromRequest = t('error_hint.notNegativeOrZero');
            errors[index] = error;
        } else if (seen.has(requestFee.fromRequest)) {
            error.fromRequest = t('error_hint.error_unique');
            errors[index] = error;
        }

        if (!isMoneyAmount(requestFee.price)) {
            error.price.amount = t('error_missing.fill_in_price');
            errors[index] = error;
        } else if (validatePrice(requestFee.price.amount)) {
            error.price.amount = `${t('error_hint.error_invalid_format')} (######.00)`;
            errors[index] = error;
        }

        seen.add(requestFee.fromRequest);
    });

    if (errors.length > 0) return errors;
};
const validateBrandingSettingsUrl = multiLangText => {
    const err = Object.entries(multiLangText).filter((entry, i) => {
        const clean = entry[1].replace(/<[^>]*>/g, '');
        return !URL.canParse(clean);
    });

    return err;
};
const asyncValidate = (values, dispatch, props, blurredField) => {
    return integrationAsyncValidate(props.t, Entities.BOOKING_INTEGRATION.repository, values, blurredField);
};

const onSubmit = (data, ownProps) => {
    try {
        const selectedCompany = ownProps.busCompanies.find(company => company._links.self.href === data.company);

        if (selectedCompany != null) {
            Object.keys(data.requestFees).forEach(key => {
                setMoneyCurrency(data.requestFees[key].price, selectedCompany.currency);
            });
            Object.keys(data.requestFeesBusRequest).forEach(key => {
                setMoneyCurrency(data.requestFeesBusRequest[key].price, selectedCompany.currency);
            });

            Object.keys(data.offerCreationFees).forEach(key => {
                setMoneyCurrency(data.offerCreationFees[key].price, selectedCompany.currency);
            });

            if (data.minIntegrationRequestFee)
                data.minIntegrationRequestFee = {
                    amount: data.minIntegrationRequestFee.amount,
                    currency: selectedCompany.currency,
                };
        }
    } catch (error) {
        console.error('Error in integration-edit-form onSubmit', error);
    }

    ownProps.onSubmit(data);
};

const onSubmitFail = (errors, dispatch) => {
    if (!errors) return;

    if (errors.requestFees || errors.requestFeesBusRequest || errors.fee) dispatch(setSliderIndex(1));
    else if (errors.themeOverrides || errors.translationOverrides) dispatch(setSliderIndex(3));
    else dispatch(setSliderIndex(0));
};

const selector = formValueSelector('integrationEditForm');

const mapStateToProps = (state, ownProps) => {
    return {
        feeType: selector(state, 'feeType'),
        settings: selector(state, 'settings'),
        company: selector(state, 'company'),
        disableDriverRoomsChoice: selector(state, 'settings.booking.disableDriverRoomsChoice'),
        forceCustomerToOrganizeHotelRoom: selector(state, 'settings.booking.forceCustomerToOrganizeHotelRoom'),
        enableBookOrRequestOfferOptionAtCheckout: selector(
            state,
            'settings.booking.enableBookOrRequestOfferOptionAtCheckout',
        ),
        allCompanies: selector(state, 'allCompanies'),
        disableResultFilter: selector(state, 'settings.searchResults.disableResultFilter'),
        onSubmit: data => onSubmit(data, ownProps),
    };
};

IntegrationEditForm = reduxForm({
    form: 'integrationEditForm',
    onSubmitFail,
    validate,
    asyncValidate,
    asyncBlurFields: ['name', 'url'],
})(IntegrationEditForm);

IntegrationEditForm = connect(mapStateToProps, null, null, { withRef: true })(IntegrationEditForm);

export default IntegrationEditForm;
